import {
  ApartmentOutlined,
  AuditOutlined,
  BarChartOutlined,
  BookOutlined,
  BuildOutlined,
  ContactsOutlined,
  CustomerServiceOutlined,
  FileProtectOutlined,
  FileTextOutlined,
  GlobalOutlined,
  HomeOutlined,
  InboxOutlined,
  InfoCircleOutlined,
  PictureOutlined,
  ProductOutlined,
  ProjectOutlined,
  QuestionCircleOutlined,
  SettingOutlined,
  SolutionOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { MENU_PERMISSIONS as M, PERMISSIONS as P } from './permissions';

export interface AdminMenuNode {
  key: string;
  label: string;
  path?: string;
  permission?: string;
  icon?: React.ReactNode;
  children?: AdminMenuNode[];
}

export const adminMenu: AdminMenuNode[] = [
  { key: 'dashboard', label: '大屏', path: '/dashboard', permission: M.dashboard, icon: <BarChartOutlined /> },
  {
    key: 'access', label: '成员与权限', permission: P.membersRead, icon: <TeamOutlined />,
    children: [
      { key: 'members', label: '成员管理', path: '/members', permission: P.membersRead },
      { key: 'member-roles', label: '成员角色', path: '/member-roles', permission: P.rolesManage },
    ],
  },
  { key: 'site-settings', label: '站点配置', path: '/site-settings', permission: M.siteSettings, icon: <GlobalOutlined /> },
  { key: 'home', label: '首页', path: '/pages/home', permission: M.home, icon: <HomeOutlined /> },
  {
    key: 'products-group', label: '产品管理', permission: M.products, icon: <ProductOutlined />,
    children: [
      { key: 'products-page', label: '产品列表页配置', path: '/products/page', permission: M.products },
      { key: 'products', label: '产品列表', path: '/products', permission: M.products },
      { key: 'parameter-template', label: '基础参数模板', path: '/products/parameter-template', permission: M.products },
      { key: 'comparison-page', label: '产品对比页', path: '/products/comparison-page', permission: M.products },
    ],
  },
  { key: 'design-yours', label: 'Design Yours', path: '/pages/design-yours', permission: M.designYours, icon: <BuildOutlined /> },
  {
    key: 'projects-group', label: '项目管理', permission: M.projects, icon: <ProjectOutlined />,
    children: [
      { key: 'projects-page', label: '页面配置', path: '/projects/page', permission: M.projects },
      { key: 'projects', label: '项目列表', path: '/projects', permission: M.projects },
    ],
  },
  {
    key: 'solutions-group', label: '解决方案', permission: M.solutions, icon: <SolutionOutlined />,
    children: [
      { key: 'solutions-page', label: '页面配置', path: '/solutions/page', permission: M.solutions },
      { key: 'solutions', label: '解决方案列表', path: '/solutions', permission: M.solutions },
    ],
  },
  { key: 'after-sales', label: '售后支持', path: '/pages/after-sales', permission: M.afterSales, icon: <CustomerServiceOutlined /> },
  { key: 'quality', label: '质量验收', path: '/quality-certifications', permission: M.quality, icon: <FileProtectOutlined /> },
  { key: 'about-us', label: '关于我们', path: '/pages/about-us', permission: M.aboutUs, icon: <InfoCircleOutlined /> },
  { key: 'resources', label: '资源中心', path: '/resources', permission: M.resources, icon: <BookOutlined /> },
  { key: 'process', label: '服务流程', path: '/pages/process', permission: M.process, icon: <ApartmentOutlined /> },
  { key: 'faq', label: 'FAQ', path: '/faq', permission: M.faq, icon: <QuestionCircleOutlined /> },
  {
    key: 'contact-group', label: '咨询', permission: M.contact, icon: <ContactsOutlined />,
    children: [
      { key: 'contact-page', label: '页面配置', path: '/contact/page', permission: M.contact },
      { key: 'inquiries', label: '询盘记录', path: '/inquiries', permission: M.contact },
    ],
  },
  { key: 'media', label: '媒体库', path: '/media', permission: M.media, icon: <PictureOutlined /> },
  { key: 'audit-logs', label: '操作日志', path: '/audit-logs', permission: P.auditRead, icon: <AuditOutlined /> },
];

export const pageLabels: Record<string, string> = {
  dashboard: '大屏', members: '成员管理', 'member-roles': '成员角色', 'site-settings': '站点配置',
  pages: '页面配置', home: '首页', products: '产品管理', projects: '项目管理', solutions: '解决方案',
  'design-yours': 'Design Yours', 'after-sales': '售后支持', 'quality-certifications': '质量验收',
  'about-us': '关于我们', resources: '资源中心', process: '服务流程', faq: 'FAQ', contact: '咨询',
  inquiries: '询盘记录', media: '媒体库', 'audit-logs': '操作日志', page: '页面配置',
  'parameter-template': '基础参数模板', 'comparison-page': '产品对比页', new: '新增',
};
